import React, { useState } from "react"
import * as styles from "./featuredVideo.module.scss"
import Img from "gatsby-image"
import { PlayIcon } from "../../../svgs/play"
import YoutubeVideo from "../YoutubeVideo"

const FeaturedVideo = ({ featuredVideoData }) => {
  const [playVideo, setPlayVideo] = useState(false)
  return (
    <div className={styles.featured_video_container}>
      <h3 className="yellow_border">{featuredVideoData?.title}</h3>
      <p>{featuredVideoData?.description?.description}</p>
      <div className={styles.video_wrapper}>
        <Img
          fluid={featuredVideoData?.backgroundImage?.fluid}
          className={styles.featured_section_img}
        ></Img>
        <div
          onClick={() => {
            setPlayVideo(true)
          }}
        >
          {/* <PlayIcon className={styles.featured_play_btn} /> */}
        </div>
        {
            playVideo && featuredVideoData.backgroundVideo?.file?.url && 
            <YoutubeVideo
            width="100%"
            height="100%"
            className={`${styles.video} ${playVideo ? styles.show : ""}`}
            videoSrcURL={featuredVideoData.backgroundVideo?.file.url}
            playVideo={playVideo}
          ></YoutubeVideo>
          }
      </div>
    </div>
  )
}

export default FeaturedVideo
